import { useEffect, useRef, useState } from "react";
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";

export default function BeforeStartItem({ number, title, text }) {
  const ref = useRef(null);
  const observer = useIntersectionObserver(ref, {
    stopObserve: true,
    threshold: 1,
    rootMargin: "0px 0px 0px 50%",
  });
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    if (observer && !isAnimated && observer.isIntersecting) {
      setIsAnimated(true);
    }
  }, [observer, isAnimated]);

  return (
    <li className="xpb-before-start__item" ref={ref}>
      <div
        className={`xpb-before-start__item-left ${isAnimated ? "active" : ""}`}
      >
        <div className="xpb-before-start__icon" />
        <figure className="xpb-before-start__number" aria-label={number} />
        <div className="xpb-before-start__glyph" />
      </div>
      <div
        className={`xpb-before-start__item-right ${isAnimated ? "active" : ""}`}
      >
        <h5>{title}</h5>
        <p>{text}</p>
      </div>
    </li>
  );
}
